import React from 'react';
import { FadeIn, ExitingPersistence, isReducedMotion } from '@atlaskit/motion';
import { useTransitionView } from '../../../controllers/use-transition-view/index.tsx';
import type { MinimizedTransitionProps } from './types.tsx';

export const MinimizedTransition = ({
	children,
	renderCondition,
}: MinimizedTransitionProps): React.JSX.Element | null => {
	const { onFinishAnimation, shouldRenderView } = useTransitionView('minimized', renderCondition);

	if (isReducedMotion()) {
		if (renderCondition) {
			return <>{children({ transitionProps: {} })}</>;
		}
		return null;
	}
	return (
		<ExitingPersistence>
			{shouldRenderView && (
				<FadeIn
					entranceDirection="bottom"
					exitDirection="bottom"
					duration="medium"
					onFinish={onFinishAnimation}
				>
					{(fadeInProps) => children({ transitionProps: { ...fadeInProps } })}
				</FadeIn>
			)}
		</ExitingPersistence>
	);
};
